import React, { Component } from 'react';
import {
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
} from 'recharts';
import { colors, chartColors } from '../../style/colors';
import { formatDollarValue } from '../../shared/chartUtility';

class CostHorizontalBarChart extends Component {
  ctx = CanvasRenderingContext2D;
  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.calculateOnUpdate) {
      return true;
    } else {
      if (nextProps.lastUpdateType === 'calculation') {
        return true;
      } else {
        return false;
      }
    }
  }

  measureText = text => {
    this.ctx = document.createElement('canvas').getContext('2d');
    this.ctx.font = '12px "Roboto"';

    return this.ctx.measureText(text).width;
  };

  leftMargin = () => {
    let leftMargin = 0;
    for (const data of this.props.chartData) {
      const textWidth = this.measureText(data.name.toString().split(' ')[0]);

      if (textWidth > leftMargin) {
        leftMargin = textWidth;
      }
    }
    leftMargin = Math.max(0, leftMargin - 90);
    return leftMargin;
  };

  chartColors = () => {
    let newChartColors = [...chartColors];
    if (!this.props.chartData[0].Baseline) {
      newChartColors.unshift(chartColors[0]);
    }
    return newChartColors;
  };

  render() {
    const newChartColors = this.chartColors();
    const formatter = value => formatDollarValue(value);
    const leftMargin = this.leftMargin();

    let isAnimationActive = true;
    if (this.props.disableAnimation) {
      isAnimationActive = false;
    }

    let isToolTipsActive = true;
    if (this.props.disableToolTips) {
      isToolTipsActive = false;
    }

    let yMax = 0;
    this.props.chartData.forEach(dataPoint => {
      this.props.proposalNames.forEach(proposalName => {
        yMax = Math.max(yMax, dataPoint[proposalName]);
      });
    });
    yMax = yMax * 1.1;

    return (
      <React.Fragment>
        <ResponsiveContainer height="100%" width="99%">
          <BarChart
            data={this.props.chartData}
            margin={{ top: 0, right: 30, left: leftMargin, bottom: 5 }}
            onMouseMove={e => this.props.showComparisons(e)}
            layout="vertical"
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              type="number"
              dataKey="Baseline"
              tickFormatter={formatter}
              domain={[0, yMax]}
            />
            <YAxis type="category" dataKey="name" width={115} />
            {isToolTipsActive && (
              <Tooltip formatter={formatter} isAnimationActive={false} />
            )}
            <Bar
              dataKey="Baseline"
              fill={newChartColors[0]}
              isAnimationActive={isAnimationActive}
            />
            {this.props.proposalIsChanged && (
              <Bar
                dataKey={this.props.currentProposalImpactName}
                fill={colors.lightblue}
                isAnimationActive={isAnimationActive}
              />
            )}
            <Bar
              dataKey={this.props.currentProposalName}
              fill={newChartColors[1]}
              isAnimationActive={isAnimationActive}
            />

            {this.props.comparedProposalsNames.map((name, i) => {
              return (
                <Bar
                  type="linear"
                  key={name}
                  dataKey={name}
                  fill={newChartColors[i + 2]}
                  isAnimationActive={isAnimationActive}
                />
              );
            })}
          </BarChart>
        </ResponsiveContainer>
      </React.Fragment>
    );
  }
}

export default CostHorizontalBarChart;
